<template>
    <div v-if="banner && ((pc && detect == 'pc') || (mobile && detect == 'mobile'))" class="main-visual swiper-container">
        <div class="swiper-wrapper">
            <div v-for="(slide, index) in banner.slides" :key="index" class="swiper-slide">
                <component :is="dynamicComponent(slide.url)" :to="slide.url" :href="slide.url">
                    <picture>
                        <source :srcset="slide.image" media="(max-width:1200px)">
                        <img :src="slide.image" alt="">
                    </picture>
                </component>
            </div>
        </div>
        <div class="main-visual__controls">
            <div class="main-visual__prev"></div>
            <div class="main-visual__next"></div>
            <div class="pagination"></div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
export default {
    props: {
        pc: Boolean,
        mobile: Boolean
    },
    data(){
        return{
            detect,
            banner: null,
            visuals:[
                { link: 'javascript:', pc: '/images/main/v1.jpg', mo: '/images/main/v1-mo.jpg' },
                { link: 'javascript:', pc: '/images/main/v2.jpg', mo: '/images/main/v2-mo.jpg' },
                { link: 'javascript:', pc: '/images/main/v3.jpg', mo: '/images/main/v3-mo.jpg' }
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { banner } = await api.v1.banners.get({ code: this.$attrs.code });
            this.banner = banner;

            this.$nextTick(() => {
                var mainVisual = new Swiper ('.main-visual', {
                    allowTouchMove: false,
                    centeredSlides: true,
                    spaceBetween : 0,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 300,
                    loop: true,
                    pagination: {
                        el: '.main-visual .pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-visual__next',
                        prevEl: '.main-visual__prev'
                    },
                    breakpoints: {
                        1200: {
                            allowTouchMove: true,
                        }
                    }
                });
            });
        },
        dynamicComponent(url){
            return (url || '').indexOf("/") == 0 ? "router-link" : "a";
        }
    },
};
</script>
<style lang="scss" scoped>
.main-visual{
    width: 100vw;
    &__controls { z-index: 2; position: absolute; top: 50%; left: 40px; transform: translateY(-50%); }
    &__prev,
    &__next { width: 36px; height: 36px; background: url('/images/main/arrow-up-light.png') no-repeat center / auto 14px; }
    &__next { background-image: url('/images/main/arrow-down-light.png'); }
    picture { overflow: hidden; display: block; }
    picture img { width: 100%; }
    .swiper-pagination-bullets { flex-direction: column; }
    ::v-deep .swiper-pagination-bullet { margin: 5px 0; width: 10px; height: 10px; background: rgba(255,255,255,0); border: 2px solid #fff; border-radius: 10px; opacity: 1; transition: all ease .3s; }
    ::v-deep .swiper-pagination-bullet-active { height: 40px; background: rgba(255,255,255,1); }
}
@media(max-width:1200px){
    .main-visual{
        &__controls { top: auto; bottom: 50px; left: 0; width: 100%; text-align: center; transform: none; }
        &__prev,
        &__next { display: none; }
        picture { height: auto; }
        picture img { position: static; width: 100%; height: auto; transform: none; }
        .swiper-pagination-bullets { flex-direction: row; }
        ::v-deep .swiper-pagination-bullet { margin: 0 2px; }
        ::v-deep .swiper-pagination-bullet-active { width: 25px; height: 10px; }
    }
}
@media(max-width:768px){
    
}
</style>